import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home';


Vue.use(Router);




export default new Router({

  routes:[
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
       path:'/',
       name:'questions',
       component: () => import(/* webpackChunkName: "questions" */ './views/Questions.vue')

    },
    {
      path:'/result-index/',
      name:'result-index',
      component: () => import(/* webpackChunkName: "result-index" */ './views/ResultIndex.vue')
    },
    {
      path:'/result-detail/',
      name:'result-detail',
      component: () => import(/* webpackChunkName: "result-detail" */ './views/ResultDetail.vue')
    },  
  ],

});

